///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export const PARAM_BASE_URL = 'baseUrl';
export const PARAM_CUSTOMER_ID = 'company_id';
export const PARAM_PROJECT_ID = 'project_id';
export const PARAM_TREE_ID = 'tree_id';
export const PARAM_PRODUCT_TYPE = 'product_type';
export const PARAM_CONFIGURATION = 'configuration_tab';
export const PARAM_PRODUCT_NAME = 'product_name';
export const PARAM_BBOX = 'bbox';

export const CUSTOMER_FILTER = 'customerFilter';
export const PARAM_FILTER = 'filter';
export const PARAM_PROJECT_FILTER = 'projectFilter';
